module.exports = __webpack_public_path__ + "img/home_logo_v1.d0af16ba.png";